import { DateRange, utc }            from 'rewire-common';
import { Modal, Form, IFormContext } from 'rewire-ui';
import { EventEmitter }              from 'events';
import DataMutations                 from '../graphql/Mutations';
import DataQueries                   from '../graphql/Queries';
import { notifications }             from '../ui/Notifications';
import { getNameSearcher }           from '../utility/Searchers';
import { TimecardTestInsertInput }   from '../DataTypes';

class AddTimecardTestDialogModel extends Modal {
  form: Form;
  private __onEvent: EventEmitter;
  private __dateDurationDays = 6;

  constructor() {
    super('Add Timecard Test');

    const employeeFilter = {
      field: 'isPayable',
      eq:    false,
    };
    const employeeSearcher = getNameSearcher('employees', () => employeeFilter);
    const tagSearcher      = {
      async search(search?: string) {
        return await DataQueries.getTags('documents', search);
      },
      map(item?: any) {
        return (item && !Array.isArray(item) && item) || '';
      }
    };

    this.form = Form.create((form: IFormContext) => ({
      name:           form.string().label('Test Description').validators('required').placeholder('enter Test Description').autoFocus(),
      employee:       form.reference(employeeSearcher).label('Employee').validators('required').placeholder('enter Employee'),
      effectiveStart: form.date().label('Effective Start').validators('required').placeholder('enter Effective Start').onValueChange(this.handleEffectiveStartChange),
      effectiveEnd:   form.date().label('Effective End').validators('required').placeholder('enter Effective End').disabled(() => true),
      code:           form.string().label('Code').placeholder('enter code'),
      tags:           form.multiselectautocomplete(tagSearcher, {chipLimit: 3, inputAdd: (v: string) => v}).label('Tags').placeholder('enter Tags'),
    }));
    this.action('cancel')
        .action('save', this.submit, { variant: 'contained', type: 'submit' });

    this.__onEvent  = new EventEmitter();
  }

  reset() {
    this.form.reset();
  }

  load() {
    this.reset();
    const currDate                       = utc();
    this.form.field.effectiveStart.value = currDate;
    this.form.field.effectiveEnd.value   = currDate.add(this.__dateDurationDays);
    this.open();
  }

  handleEffectiveStartChange = (form: Form, v?: any) => {
    form.field.effectiveEnd.value = v ? v.add(this.__dateDurationDays) : undefined;
  };

  get onEvent() {
    return this.__onEvent;
  }

  private save = async (): Promise<boolean> => {
    const timecardTestInput: TimecardTestInsertInput = {
      employeeId: this.form.field.employee.value.id,
      effective:  new DateRange(this.form.field.effectiveStart.value, this.form.field.effectiveEnd.value),
      name:       this.form.field.name.value,
      code:       this.form.field.code.value,
      tags:       this.form.field.tags.value,
    };

    const result = await DataMutations.insertTimecardTests('', [timecardTestInput]);
    if (result && result[0]) {
      notifications.success('Timecard Test Created');
      this.onEvent.emit('submit', result[0]);
      return true;
    }

    notifications.error('Timecard Test Creation Failed');
    return false;
  };

  submit = async () => {
     return await this.form.submitAsync(this.save);
  };
}

const addTimecardTestDialogModel = new AddTimecardTestDialogModel();
export default addTimecardTestDialogModel;
